window.addEventListener(
  "message",
  function (event) {
    let json;
    try {
      json = JSON.parse(event.data);
    } catch (error) {
      console.log(error);
      return;
    }

    const companyName = json.companyName;
    const firstName = json.firstName;
    const lastName = json.lastName;
    const email = json.email;

    const url = "https://spacely.co.jp/api_collaborate/v1/users/spacely_trial";

    $.ajax({
      type: "POST",
      url: url,
      headers: {
        Authorization: "Spacely 48dc580b"
      },
      data: {
        company_name: companyName,
        first_name: firstName,
        last_name: lastName,
        email: email
      }
    })
      .done(function (data) {
        console.log(data);
      })
      .fail(function () {});
  },
  false
);
